import * as yup from 'yup';

import { Button } from '../../../component/common/button/Button';
import { RowActionsDropdown } from '../../../component/common/table/action-dropdown/RowActionsDropdown';

export const getMenuCategoryColumnDefinition = (
  onEdit,
  onView,
  onDelete,
  customAction,
  customActionText,
  customActionIcon
) => [
  {
    id: 'imageUrl',
    accessorKey: 'imageUrl',
    size: 72,
    minSize: 72,
    maxSize: 72,
    header: '',
    filterFn: 'tableFilterFn',
    cell: ({ row }) => (
      <img
        src={row.original.imageUrl}
        alt={row.original.name}
        style={{ width: '32px', height: '32px', margin: '8px' }}
      />
    )
  },
  {
    id: 'name',
    accessorKey: 'name',
    size: 180,
    minSize: 180,
    header: 'Name',
    filterFn: 'tableFilterFn'
  },
  {
    id: 'active',
    accessorKey: 'active',
    size: 180,
    minSize: 180,
    header: 'Active',
    filterFn: 'tableFilterFn',
    cell: ({ row }) => (row.original.active ? 'Yes' : 'No')
  },
  {
    id: 'actions',
    header: '',
    size: customAction ? 100 : 40,
    minSize: customAction ? 100 : 40,
    maxSize: customAction ? 100 : 40,
    disableExport: true,
    enableSorting: false,
    cell: ({ row }) => {
      if (customAction && typeof customAction === 'function') {
        return (
          <Button onClick={() => customAction(row.original)} small outline>
            {customActionIcon}
            {customActionText}
          </Button>
        );
      }

      const availableActions = [
        onView && { label: 'View', value: 'view', onSelect: onView },
        onEdit && row.original.filterEnabled && { label: 'Edit', value: 'edit', onSelect: onEdit },
        onDelete &&
          row.original.filterEnabled && { label: 'Delete', value: 'delete', onSelect: onDelete }
      ].filter(Boolean);

      return <RowActionsDropdown row={row} actions={availableActions} />;
    }
  }
];

export const MENU_CATEGORY_TABS = (icons) => [
  {
    label: 'Details',
    fields: [
      {
        type: 'input',
        name: 'name',
        label: 'Name',
        required: true,
        validation: yup.string().required('Name is required')
      },
      {
        type: 'yesno',
        name: 'active',
        label: 'Active',
        required: true,
        defaultValue: true,
        validation: yup.boolean().required('Please select Yes or No')
      },
      {
        type: 'input',
        name: 'color',
        label: 'Color (Hex)',
        required: true,
        validation: yup.string().required('Color is required')
      },
      {
        type: 'hidden'
      },
      {
        type: 'icon',
        name: 'imageUrl',
        label: 'Icon',
        required: true,
        colSpan: 2,
        icons,
        validation: yup.string().required('Icon is required')
      }
    ]
  }
];
